/* ══════════════════════════════════════
   FURNSWIFT THEME JS — SHOPIFY CART API
   ══════════════════════════════════════ */

const FS = (function() {

  // ── Cart Drawer ──
  function toggleCart() {
    const drawer = document.getElementById('cart-drawer');
    drawer.classList.toggle('open');
    if (drawer.classList.contains('open')) loadCart();
  }

  function loadCart() {
    const body = document.getElementById('cart-body');
    if (!body) return;
    body.innerHTML = '<div class="cart-loading">Loading...</div>';
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => renderCart(cart))
      .catch(() => { body.innerHTML = '<p style="text-align:center;color:red;padding:20px">Could not load cart.</p>'; });
  }

  function renderCart(cart) {
    const body = document.getElementById('cart-body');
    if (!body) return;

    updateBubble(cart.item_count);

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><div style="font-size:56px;margin-bottom:12px">🛋️</div><p style="color:#7A7570;margin-bottom:16px">Your cart is empty</p><a href="/collections/all" class="btn-primary btn-sm" onclick="FS.toggleCart()">Start Shopping</a></div>';
      const footer = document.getElementById('cart-footer');
      if (footer) footer.style.display = 'none';
      return;
    }

    body.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <div class="cart-item__emoji">
          ${item.image ? `<img src="${item.image}" style="width:100%;height:100%;object-fit:cover;border-radius:6px">` : '🛋️'}
        </div>
        <div class="cart-item__info">
          <div class="cart-item__name">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:12px;color:#7A7570">${item.variant_title}</div>` : ''}
          <div class="cart-item__price">${formatMoney(item.final_price)}</div>
          <div class="cart-item__qty">
            <button class="cart-qty-btn" onclick="FS.updateQty(${item.variant_id}, ${item.quantity - 1})">−</button>
            <span class="cart-qty-num">${item.quantity}</span>
            <button class="cart-qty-btn" onclick="FS.updateQty(${item.variant_id}, ${item.quantity + 1})">+</button>
          </div>
        </div>
      </div>`).join('');

    let footer = document.getElementById('cart-footer');
    if (!footer) {
      footer = document.createElement('div');
      footer.id = 'cart-footer';
      footer.className = 'cart-footer';
      document.querySelector('.cart-drawer__panel').appendChild(footer);
    }
    footer.style.display = 'block';
    footer.innerHTML = `
      <div class="cart-total-row">
        <span class="cart-total-label">Total</span>
        <span class="cart-total-val">${formatMoney(cart.total_price)}</span>
      </div>
      <a href="/checkout" class="btn-primary" style="width:100%;justify-content:center;display:flex">Checkout →</a>
      <a href="/cart" style="display:block;text-align:center;margin-top:10px;font-size:13px;color:var(--muted)">View full cart</a>`;
  }

  function updateQty(variantId, qty) {
    const updates = {};
    updates[variantId] = qty;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    }).then(r => r.json()).then(cart => renderCart(cart));
  }

  function updateBubble(count) {
    document.querySelectorAll('.cart-bubble').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // ── Toast ──
  function toast(msg) {
    const el = document.getElementById('fs-toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('show');
    setTimeout(() => el.classList.remove('show'), 3000);
  }

  // ── Mobile nav ──
  function toggleMobileNav() {
    document.getElementById('mobile-nav')?.classList.toggle('open');
  }

  // ── Option buttons ──
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('option-btn')) {
      e.target.closest('.option-btns')?.querySelectorAll('.option-btn').forEach(b => b.classList.remove('active'));
      e.target.classList.add('active');
    }
    if (e.target.classList.contains('filter-btn')) {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      e.target.classList.add('active');
    }
    if (e.target.classList.contains('config-chip')) {
      e.target.closest('.config-chips')?.querySelectorAll('.config-chip').forEach(b => b.classList.remove('active'));
      e.target.classList.add('active');
      updateCtaPrice();
    }
  });

  // ── CTA price updater ──
  const ctaPrices = { Velvet:80, Linen:0, Leather:200, 'U-Shape':0, 'L-Shape':-200, Corner:-150, Straight:-350 };
  function updateCtaPrice() {
    const fa = document.querySelector('[data-chip-group="fabric"] .config-chip.active');
    const ca = document.querySelector('[data-chip-group="shape"] .config-chip.active');
    const total = 1299 + (fa ? ctaPrices[fa.textContent]||0 : 80) + (ca ? ctaPrices[ca.textContent]||0 : 0);
    const el = document.getElementById('cta-price');
    if (el) el.textContent = '£' + total.toLocaleString();
  }

  // ── Load cart count on page load ──
  document.addEventListener('DOMContentLoaded', function() {
    fetch('/cart.js').then(r => r.json()).then(c => updateBubble(c.item_count));
    updateCtaPrice();
  });

  return { toggleCart, loadCart, updateQty, toast, toggleMobileNav };
})();

// ── Money formatter ──
function formatMoney(cents) {
  return '£' + (cents / 100).toFixed(2).replace(/\.00$/, '');
}
